<div class="border border-border rounded-lg bg-surface">
  <!-- Header -->
  <div
    [class.cursor-pointer]="collapsible()"
    [class.hover:bg-surface-high]="collapsible()"
    [class.rounded-lg]="isCollapsed()"
    [class.rounded-t-lg]="!isCollapsed()"
    class="flex items-center gap-3 p-4 transition-colors"
    (click)="toggleCollapse()"
    (keydown.enter)="toggleCollapse()"
    tabindex="0"
  >
    @if (icon()) {
    <div
      class="w-9 h-9 rounded-lg bg-primary-low-contrast text-primary flex items-center justify-center flex-shrink-0"
    >
      <lucide-icon [name]="icon()!" class="w-5 h-5"></lucide-icon>
    </div>
    }
    <div class="flex-1 min-w-0">
      <h3 class="text-sm font-semibold text-foreground">{{ title() }}</h3>
    </div>
    @if (collapsible()) {
    <lucide-icon
      name="ChevronUp"
      class="w-5 h-5 text-muted-foreground flex-shrink-0 transition-transform duration-300"
      [class.rotate-180]="isCollapsed()"
    ></lucide-icon>
    }
  </div>

  <!-- Content (single default <ng-content> slot so Angular projects for both collapsible and static form cards) -->
  <div [class]="collapsible() ? (isCollapsed() ? 'hv-collapse-grid' : 'hv-collapse-grid is-open') : 'contents'">
    <div [class]="collapsible() ? 'hv-collapse-inner' : 'contents'">
      <div class="p-4 pt-0 space-y-4">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
